module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/157-republic-of-the-congo-17465b3ceae9f711b022973296aaefe0.svg";